// extracted by mini-css-extract-plugin
export default {"primitiveImg":"primitiveImg___VkCiH","image":"image___BCkCB","imagePreview":"imagePreview___qFyP3"};